var map = {
	"./bomming_75x75.png": 2471,
	"./car_75x75.png": 7860,
	"./care_75x75.png": 7625,
	"./collision_vehicle_75x75.png": 595,
	"./earthquack_75x75.png": 607,
	"./explosion_75x75.png": 7123,
	"./fire_75x75.png": 2022,
	"./flood_75x75.png": 2078,
	"./flooddamage_landslide_75x75.png": 5194,
	"./glass_75x75.png": 4406,
	"./prio_75x75.png": 9660,
	"./refusal_75x75.png": 4750,
	"./storm_75x75.png": 2073,
	"./theft_burglary_75x75.png": 2416,
	"./thunder_electricity_75x75.png": 6418,
	"./water_75x75.png": 9019,
	"./web_archive_75x75.png": 6215,
	"./web_dearchive_75x75.png": 6004,
	"./web_refusal_75x75.png": 1157,
	"./web_refusal_black_75x75.png": 2241
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1595;